import './Mapa.css';

const Mapa = () => {
    return (
        <section className="mapa-section" id="contatos">
            <div className="section-header">
                <h2 className="section-title">ONDE <span className="highlight">ESTAMOS</span></h2>
                <div className="divider"></div>
            </div>
            <div className="mapa-container">
                <iframe title="mapa-google"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14219.82040866695!2d-48.6354335!3d-26.99997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce43e3709765f1%3A0x14252db1947a63f9!2sOficina%20Mec%C3%A2nica%20Stuttgart%20Motors!5e0!3m2!1spt-BR!2sbr!4v1721661865892!5m2!1spt-BR!2sbr"
                    width="100%"
                    height="450"
                    style={{ border: 0, borderRadius: "12px" }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
            
            <footer className="footer-simple">
                <p>&copy; {new Date().getFullYear()} Stuttgart Motors. Todos os direitos reservados.</p>
            </footer>
        </section>
    );
}


export default Mapa;